
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CoverageEnabledCard',
  props: {
    dsn: {
      type: String,
      required: true
    },
    hasTestCoverage: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
})
